"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalNode = void 0;
const tree_node_1 = require("./tree.node");
class InternalNode extends tree_node_1.TreeNode {
    _children;
    constructor(originalNode, parent) {
        super(originalNode, parent);
        this._children = [];
    }
    init(allNodes) {
        this.children =
            // @ts-ignore
            this.originalNode.children?.flatMap(child => {
                const astChild = allNodes.get(child);
                if (!astChild)
                    return [];
                astChild.init(allNodes);
                astChild.parent = this;
                return astChild ?? [];
            }) ?? [];
    }
    get text() {
        return ''; // internal nodes cannot have text OR it should return its children toString()?
    }
    set text(text) {
        return; // cannot set text on internal nodes
    }
    get parent() {
        return this._parent;
    }
    set parent(parent) {
        this._parent = parent;
    }
    get originalNode() {
        return this._originalNode;
    }
    get children() {
        return this._children;
    }
    set children(children) {
        this._children = children;
    }
    toString() {
        if (!this.hasChildren())
            return '';
        return this._children.map(child => child.toString()).join('');
    }
    hasChildren() {
        return this.children.length > 0;
    }
    translate(opts) {
        return this._children
            .map(child => {
            return child.translate(opts);
        })
            .join('');
    }
    visitChildren(v) {
        this._children?.forEach(child => {
            child.accept(v);
        });
    }
}
exports.InternalNode = InternalNode;
